import React from 'react';
import '.././assets/lazy-image.scss';
import classNames from 'classnames';

class LazyImage extends React.Component {
    is_cached = src => {
      //Cached images don't flash and get shown immediately
      let image = new Image();
      image.src = src;
      return image.complete;
    };
    
    constructor(props) {
      super(props);
      this.element = React.createRef();
      this.state = {
        try: false,
        visible: false,
        shown: this.is_cached(this.props.main),
        error: false,
        testnum: 1.0,
        teststr: "test"
      };
    }
    componentDidMount() {
      this.observer = new IntersectionObserver(this.handleVisibilityChange, {
        threshold: 0.5
      });
      this.observer.observe(this.element.current);
      this.setState({ try: true });
    }
    imageLoaded = () => {
      this.setState({ shown: true, error: false });
    };
    imageError = () => {
      if (!this.state.shown) this.setState({ error: true });
    };
    handleVisibilityChange = e => {
      if (e[0].intersectionRatio > 0) {
        this.observer.unobserve(this.element.current);
        this.setState({ visible: true });
      }
    };
    render() {
      return (
        <div
          ref={this.element}
          className="lazyimage"
          style={{ "--height": this.props.height * 100 + "%" }}
        >
          <img
            className={classNames("image", "thumb")}
            src={`${this.props.thumb}`}
            alt={this.props.alt}
            onError={this.imageError}
          />
          {(this.state.shown || (this.state.try && this.state.visible)) && (
            <img
              className={classNames("image", "main", {
                show: this.state.shown
              })}
              src={`${this.props.main}`}
              alt={this.props.alt}
              onError={this.imageError}
              onLoad={this.imageLoaded}
            />
          )}
          {this.state.error && (
            <div
              className="error"
              title={"Image could not be loaded. " + (this.props.alt || "")}
            >
              <i class="fas fa-exclamation-circle"></i>
            </div>
          )}
        </div>
      );
    }
  } //Down to here is all you need


  export default LazyImage;